import ptBrTranslations from "./pt/translation.json";
import esESTranslations from "./es/translation.json";

const lan = {
    "pt-BR": ptBrTranslations,
    "es-ES": esESTranslations,
};

export default lan;
